import React, { ReactNode } from "react";
import clsx from "clsx";
import { Box } from "@material-ui/core";

import useStyles from "./FormLegend.style";

export const FormLegend = ({
  children,
  className,
  id,
  component = "div",
  srOnly = false,
}: {
  children: ReactNode;
  className?: string;
  id?: string;
  component?: React.ElementType;
  srOnly?: boolean;
}) => {
  const c = useStyles({});
  return (
    <Box
      className={clsx(c.root, className, { srOnly }, "form-legend")}
      id={id}
      component={component}
    >
      {children}
    </Box>
  );
};
